import React from 'react';
import { Row } from 'react-bootstrap';
import GenericApprovalSection from './GenericApprovalSection';
import { RESLCustomFields } from './RESLCustomFields';
import { ResourceRequest } from '../../hooks/incidentResourceRequestHooks';
import { ApprovalStage } from '../utils/ResourceRequestTypes';
import { isStageCompleted } from '../utils/ResourceRequestUtils';
import { useCurrentUserApprovalAuthority } from '../../../../hooks/incident/useCurrentUserApprovalAuthority';

interface RESLApprovalSectionProps {
  requestData: ResourceRequest | null;
  currentStage: ApprovalStage;
  onApprove: () => void;
  isSubmitting: boolean;
  isCompleted: boolean;
}

const RESLApprovalSection: React.FC<RESLApprovalSectionProps> = ({
  requestData,
  currentStage,
  onApprove,
  isSubmitting,
  isCompleted,
}) => {
  const stageCompleted = isStageCompleted('resl', requestData);
  const hasApprovalAuthority = useCurrentUserApprovalAuthority();

  return (
    <GenericApprovalSection
      stage="resl"
      requestData={requestData}
      currentStage={currentStage}
      onApprove={onApprove}
      isSubmitting={isSubmitting}
      isCompleted={isCompleted}
      nameField="resl_name"
      commentsField="resl_comments"
      signatureField="resl_signature"
      timestampField="resl_signature_timestamp"
      showPositionField={false}
    >
      {/* Custom RESL fields */}
      {stageCompleted ? (
        <Row className="mb-3">
          <div className="col-12">
            <RESLCustomFields
              isCompleted={true}
              isReadOnly={true}
              hasApprovalAuthority={hasApprovalAuthority}
            />
          </div>
        </Row>
      ) : (
        <RESLCustomFields
          isCompleted={isCompleted}
          hasApprovalAuthority={hasApprovalAuthority}
        />
      )}
    </GenericApprovalSection>
  );
};

export default RESLApprovalSection;
